// Mirrors GPMetals.Core.Models.WasteTracking on the API.

export enum WasteReceiptStatus {
  Draft = 0,
  Failed = 1,
  Submitted = 2,
  Amended = 3,
  Excluded = 4,
}

export enum WasteReceiptCarrierType {
  OwnCarrier = 0,
  HouseholdDropOff = 1,
  ThirdPartyCarrier = 2,
}

export type WasteReceiptView = "pending" | "submitted" | "excluded";

export interface IWasteReceiptRow {
  vehicleId: string;
  leadId: string | null;
  receiptId: string | null;
  vrm: string | null;
  stockNumber: string | null;
  make: string | null;
  model: string | null;
  vin: string | null;
  collectedOn: string | null;
  isDropOff: boolean;
  contactName: string | null;
  vehiclePostcode: string | null;
  vehicleAddress: string | null;

  status: WasteReceiptStatus | null;

  dateTimeReceived: string | null;
  weightKg: number | null;
  weightIsEstimate: boolean;
  hazardousWasteConsignmentCode: string | null;
  carrierType: WasteReceiptCarrierType | null;
  carrierRegistrationNumber: string | null;
  carrierOrganisationName: string | null;
  carrierVehicleRegistration: string | null;
  recoveryCode: string | null;

  /** Linked haulier account; while set, carrier name and registration come from it. */
  haulierAccountId: string | null;
  haulierName: string | null;

  isReady: boolean;
  issues: string[];

  wasteTrackingId: string | null;
  warnings: string[];
  failureReason: string | null;
  submittedOn: string | null;
  submittedBy: string | null;
  amendedOn: string | null;
}

/**
 * Editable fields. A single-row save sends the whole set (null clears a field); a bulk
 * patch only applies the fields that are not undefined/null.
 */
export interface IUpsertWasteReceiptDraft {
  dateTimeReceived?: string | null;
  useCollectedDateAsReceived?: boolean | null;
  weightKg?: number | null;
  weightIsEstimate?: boolean | null;
  hazardousWasteConsignmentCode?: string | null;
  carrierType?: WasteReceiptCarrierType | null;
  carrierRegistrationNumber?: string | null;
  carrierOrganisationName?: string | null;
  carrierVehicleRegistration?: string | null;
  recoveryCode?: string | null;
  /** Forces carrierType to ThirdPartyCarrier on the API; any other carrierType drops the link. */
  haulierAccountId?: string | null;
}

export interface IBulkWasteReceiptPatch {
  vehicleIds: string[];
  patch: IUpsertWasteReceiptDraft;
}

export interface IWasteReceiptSubmitResult {
  vehicleId: string;
  vrm: string | null;
  success: boolean;
  skipped: boolean;
  wasteTrackingId: string | null;
  errors: string[];
  warnings: string[];
}
